import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CompanyPolicyVersionHistoryFilterOptionDetails, CompanyPolicyVersionHistorySearchOptionDetails } from 'src/app/helpers/constants/filter-and-search/companypolicy.versionhistory.Filter&SearchOptions';
import { CompanyPolicyVersionHistoryFilterOptions } from 'src/app/helpers/enums/filters-and-searchs/companypolicy.versionhistory.search&filter.options';
import { FilterInputModel, SearchByModel } from 'src/app/models/shared/filters.model';

@Component({
  selector: 'app-policy-overiew-filter',
  templateUrl: './policy-overiew-filter.component.html',
  styleUrls: ['./policy-overiew-filter.component.scss']
})
export class PolicyOveriewFilterComponent implements OnInit {

  filterBy: FilterInputModel[] = [];
  searchBy: SearchByModel[] = [];
  isFilterInVisible = true;
  // tslint:disable-next-line: no-output-on-prefix
  @Output() onApplyFilter = new EventEmitter();

  @Output()
  resetFilters = new EventEmitter();


  // capture filter open and close events
  @Input() filterStatusParent: boolean;
  @Output() closeBtnFilterStatus = new EventEmitter<boolean>();


  constructor() {
  }

  ngOnInit(): void {
    this.loadFilterOptions();
  }

  private loadFilterOptions(): void {
    this.filterBy = [];
    this.searchBy = [];

    // filterby
    CompanyPolicyVersionHistoryFilterOptionDetails.forEach((key, value) =>
    this.filterBy.push({ name: key, id: `${value}`, group: undefined, isSelected: value === CompanyPolicyVersionHistoryFilterOptions.None })
    );

    // search by
    CompanyPolicyVersionHistorySearchOptionDetails.forEach((x, y) => {
      this.searchBy.push({
        id: y,
        name: x
      });
    });
  }

  applyFilter(filterData: any): void {
    this.onApplyFilter.emit(filterData);
  }

  onResetFilters(): void {
    this.loadFilterOptions();
    this.resetFilters.emit();
  }

  // capture filter open and close events
  closeEvent(somedata: boolean): void {
    this.filterStatusParent = somedata;
    this.closeBtnFilterStatus.emit(somedata);
  }

}
